export default __webpack_public_path__ + "static/media/warehouse-management-coming-soon.785dbbbf.svg";